<wiz-vgroup width="100%" height="100%" class="window border">

          <wiz-hgroup width="100%" verticalAlign="center" class="blackbar">
            <wiz-label [wizLabel]="fullUserLabel" width="100%" class="smallTitle white"></wiz-label>
            <wiz-icon class="basicIcon white hover small" (click)="doCancel()">close</wiz-icon>
          </wiz-hgroup>
         
          <wiz-vgroup width="100%" height="100%" style="padding-left: 10px;">
            <wiz-hgroup width="100%" verticalAlign="center">
              <wiz-icon class="basicIcon black hover" 
                [wizTooltip]="'$.common.avatar.$'" (click)="do('avatar')" tooltipPlacement="bottom">
                <mat-icon>face</mat-icon></wiz-icon>
              <wiz-label [wizLabel]="'$.common.avatar.$'"></wiz-label>
            </wiz-hgroup>
          
            <wiz-hgroup width="100%" verticalAlign="center">
              <wiz-icon class="basicIcon black hover" 
                [wizTooltip]="'$.common.support.$'" (click)="do('support')" tooltipPlacement="bottom">
                <mat-icon>chat</mat-icon></wiz-icon>
              <wiz-label [wizLabel]="'$.common.support.$'"></wiz-label>
            </wiz-hgroup>

            <wiz-hgroup width="100%" verticalAlign="center">
              <wiz-icon class="basicIcon black hover" 
                [wizTooltip]="'$.common.help.$'" (click)="do('help')" tooltipPlacement="bottom"><mat-icon>help_outline</mat-icon></wiz-icon> 
              <wiz-label [wizLabel]="'$.common.help.$'"></wiz-label>
            </wiz-hgroup>

            <wiz-hgroup width="100%" verticalAlign="center">
              <wiz-icon class="basicIcon black hover" 
                [wizTooltip]="'$.common.language.$'" (click)="do('language')" tooltipPlacement="bottom">
                <mat-icon>translate</mat-icon></wiz-icon>
              <wiz-label [wizLabel]="'$.common.language.$'"></wiz-label>
            </wiz-hgroup>

          </wiz-vgroup>


          <wiz-hgroup width="100%" horizontalAlign="end" class="blackbar" style="padding-left: 5px; padding-right: 5px;">
              <wiz-label [wizLabel]="applicationVersion" class="smallTitle white"></wiz-label>
          </wiz-hgroup>

</wiz-vgroup>
